<template>
    <div class="mt-2" >
        <points-graph></points-graph>
        <v-overlay
            :absolute="true"
            :value="noData"
            :light="true"
            :dark="false"
            opacity=".2"
        >
            <v-card
                elevation="2"
                outlined
                tile
                class="ma-5"
            >
                <v-card-text class="overlay-text">
                    Oops! No HR data is available to view here. Either you:
                    <ul class="mb-2">
                        <li>don't have your HR monitor linked to your studio;</li>
                        <li>haven't been added to your studio challenge; or</li>
                        <li>haven't accepted the invite for the challenge.</li>
                    </ul>
                    <p>Please check in with your studio manager.</p>
                </v-card-text>
            </v-card>
        </v-overlay>
        <v-overlay
            :absolute="true"
            :value="preStart"
            :light="true"
            :dark="false"
            opacity=".2"
        >
            <v-card
                elevation="2"
                outlined
                tile
                class="ma-5"
            >
                <v-card-text class="overlay-text">
                    Oops! The challenge is yet to commence. Your HR data will be available here from day 1 of the challenge. Check back here then.
                </v-card-text>
            </v-card>
        </v-overlay>
    </div>
</template>

<script>
import PointsGraph from "@/components/PointsGraph";
import {mapGetters, mapState} from "vuex";
export default {
name: "PointsDisplay",
    components: {PointsGraph},
    computed: {
        preStart () {
            return !this.noData && this.currentDay < 0
        },
        noData () {
            if (!this.workout_data) return false
            var noData = true
            this.workout_data.forEach(week => {
                if(week) {
                    noData = false
                    return
                }
            })
            return noData
        },
        ...mapState({
          workout_data: state => state.data.workout_data
        }),
        ...mapGetters({
            currentDay: 'challenge/currentDay'
        })
    }
}
</script>

<style scoped>

</style>
